import { AppModules } from '@common-modules/shared/app-modules.enum';

const buildI18nResources = (items: string[]) =>
  items.map((item) => ({ prefix: `assets/i18n/${item}/`, suffix: '.json' }));

export const commonTranslationResources = buildI18nResources([
  'common',
  'kendo',
  AppModules.WlmShared,
  AppModules.Map,
  AppModules.WlmGrid,
  AppModules.RightPanel
]);
